import { MessageCircle, Sparkles } from "lucide-react";

const SallyLauncher = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Open Sally sales assistant"
    className="group inline-flex h-12 items-center gap-2 rounded-full border border-secondary/25 bg-white/95 px-4 text-sm font-semibold text-slate-800 shadow-[0_14px_35px_rgba(32,124,151,0.22)] backdrop-blur transition hover:-translate-y-0.5 hover:border-secondary/50 hover:shadow-[0_18px_42px_rgba(32,124,151,0.28)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-secondary/20 dark:bg-gray-900/95 dark:text-gray-100"
  >
    <span className="relative flex h-7 w-7 items-center justify-center rounded-full bg-secondary text-white">
      <MessageCircle size={15} strokeWidth={2.2} />
      <Sparkles
        size={10}
        className="absolute -right-1 -top-1 text-primary transition group-hover:rotate-12"
        fill="currentColor"
      />
    </span>
    Talk to Sally
  </button>
);

export default SallyLauncher;
